import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class GuestPasses extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "guest-passes";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(guestPasses) {
        try {
            await this.$post(this.baseURL, guestPasses);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(guestPasses) {
        try {
            await this.$put(`${this.baseURL}/${guestPasses.id}`, guestPasses);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(guestPassesId) {
        try {
            await this.$delete(`${this.baseURL}/${guestPassesId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
